export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7153.2a821e61.jpg";